import { Component, OnInit, ViewChild } from '@angular/core';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, ITdDataTableSortChangeEvent, IPageChangeEvent, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { Product } from '../../purchasing/products/product';
import { ProductService } from '../../purchasing/products/product.service';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { SettingsService } from '../../../shared/services/settings.service';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-unit-price',
  templateUrl: './unit-price.component.html',
  styleUrls: ['./unit-price.component.scss']
})
export class UnitPriceComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Product[];

  columns: ITdDataTableColumn[] = [
    { name: 'collection_name', label: 'Collection' },
    { name: 'name', label: 'Design' },
    { name: 'unit_price_eur', label: 'Unit Price (EUR)' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;

  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 10;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _productService: ProductService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this._productService.getDesignPrices().subscribe(
      response => {
        this.data = response;
      },
      error => {
        console.log(error)
      },
      () => {
        this._loadingService.resolve('loading');

        this.filter();
      }
    );
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('unit_price')) {
      this._searchBox.value = this._settingsService.getSearchTerm('unit_price');
      this._searchBox.searchClicked();
    }
  }

openPriceChangeDialog(row: Product) {
    this._dialogService.openPrompt({
      title: 'Update Value',
      message: 'Enter new Unit price (EUR)',
      value: row['unit_price_eur']
    }).afterClosed().subscribe(
      (value: number) => {
        this._loadingService.register('loading');

        if (value !== undefined) {
          this._productService.updateDesignPrice(row['id'], value).subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                row['unit_price_eur'] = value +'';
                this.filter();
              } else {
                this._dialogService.openAlert({
                  title: 'Failed!',
                  message: 'Failed setting the price for the Design: ' + row['name']
                });
              }
            },
            error => {
              this._dialogService.openAlert({
                title: 'Error!',
                message: 'Error setting the price for the Design: ' + row['name'] + ": " + error
              });
              this._loadingService.resolve('loading');
            },
            () => {
              this._loadingService.resolve('loading');
            }
          );
        } else {
          this._loadingService.resolve('loading');
        }
      });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
    ? TdDataTableSortingOrder.Descending
    : TdDataTableSortingOrder.Ascending;
    
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('unit_price', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;

    //this.pageSize = pagingEvent.pageSize;
    this._settingsService.setPageSize(pagingEvent.pageSize);

    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('unit_price'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/admin/unit-price/unit-price.component.ts